import { render, staticRenderFns } from "./karyawan.vue?vue&type=template&id=0798f5e2"
import script from "./karyawan.vue?vue&type=script&lang=js"
export * from "./karyawan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports